<template>
  <div class="home">
    <div class="fixedtool">
      <div v-for="(item, i) in recommendGoods" :key="i" @click="scrollTo(item.name)">{{item.name}}</div>
    </div>
    <!--<div class="layer">
      <img :src="require('../assets/images/verification/ad.jpg')">
    </div>-->
    <div class="layer">
      <Search title="请输入..." subheading="" />
    </div>
    <div class="layer">
      <SuperNav :list="headerNav" />
    </div>
    <div class="nav_bottom"></div>
    <Banner v-if="bannerList && bannerList.length" :prop='bannerList'>
      <!--<BannerNews v-if="articleList && articleList.length" :prop='articleList' slot="news" />-->
    </Banner>
    <div class="layer">
      <HotList v-if="hotGoods.commdity && hotGoods.commdity.length" :prop="hotGoods"></HotList>
    </div>
    <!--<div class="layer">-->
      <!--<SmallBanner :prop="banner"  class="mt15"/>-->
    <!--</div>-->
    <div class="layer" v-for="(item, i) in recommendGoods" :key="i">
      <Commdity :prop="item" :floor="item.name" :index="i + 1" ></Commdity>
    </div>
  </div>
</template>

<script>
import { setCookie } from '@/utils/cookie'
import Search from '@/components/Search/index'
import Banner from '@/components/Banner/home'
//import BannerNews from '@/components/Banner/news'
import SuperNav from '@/components/SuperNav/index'
//import SmallBanner from '@/components/Banner/smallBanner'
import HotList from '@/components/CommdityList/commdityList1'
import Commdity from '@/components/CommdityList/commdityList2'

import { GoodsService } from '../service/goods.service';
export default {
  name: 'home',
  data() {
    return {
      digui: '',
      banner: [{
        src: 'https://api.goodyiyao.cn/static/upload/other/smallBanner.jpg'
      }],
      homeData: {},
    }
  },
  components: {
    Search,
    Banner,
//    BannerNews,
    HotList,
    Commdity,
    SuperNav,
//    SmallBanner
  },


  created() {
    this.getData();
  },
  mounted() {
    this.listenerScroll();
  },
  computed: {
    headerNav() {
      return this.$store.state.shop_index.headerNav
    },
    recommendGoods() {
      const indexRecommendGoods = this.$store.state.shop_index.indexRecommendGoods.filter(item => item.child && item.child.length);
      let flag;
      const stack = [ ...indexRecommendGoods ];
      flag = stack.pop();
      while(flag) {
        flag.image = GoodsService.spliceImg(flag.image || flag.original_img);
        if (flag.child && flag.child.length) {
          flag.child = flag.child.filter(item => item.goods_id || (item.child && item.child.length));
          stack.unshift(...flag.child);
        }
        flag = stack.pop();
      }
//      return indexRecommendGoods;
        let existGoods = [];
        for(let i in indexRecommendGoods){
            if(indexRecommendGoods[i].child.length != 0){
                existGoods.push(indexRecommendGoods[i]);
            }
        }
        return existGoods;
    },
    hotGoods() {
      this.$store.state.shop_index.hotGoods.forEach(item => {
        item.original_img = GoodsService.spliceImg(item.original_img);
      });
      return {
        title: "热门商品",
        tabTitle: ["家庭常备","感冒发热","肠胃用药","心脑血管"],
        bigImg_url: '/mock/images/medicine/bigCommdity.jpg',
        commdity: this.$store.state.shop_index.hotGoods,
      };
    },
    bannerList() {
      return this.$store.state.shop_index.slide.map(item => {
        item.url = GoodsService.spliceImg(item.images_url);
        return item;
      });
    },
    articleList() {
      return [{
        "id": "1",
        "title": "文章",
        "news": this.$store.state.shop_index.article
      }];
    },
  },
  methods: {
    listenerScroll() {
      // document.getElementById('app').addEventListener('scroll', (event) => {
      //   console.log(event);
      // },false);
    },
    async getData() {
      const data = await GoodsService.homeData();
      this.$store.commit('calculationNumber',data.cart_num)
      this.$store.commit('set_shopIndex',data)
    },
    shoppingCart() {
      this.$router.push('/shoppingCart')
    },
    loginOut() {
      setCookie('username','')
    },
    scrollTo(val) {
      document.getElementById('floor'+val).scrollIntoView({behavior:'smooth'})
    }
  },
  destroyed() {
    // document.getElementById('app') && document.getElementById('app').removeEventListener('scroll');
  }
}
</script>

<style scoped>

  .superNavUl li{
    float: left;
    font-size: 22px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    padding: 0 53px;
  }
  .superNavUl li.b{
    width: 250px;
    padding: 0;
    background: #1177b6;
    color: #fff;
  }
  .bannerNav{
    position: absolute;
    height: 445px;
  }
  .fixedtool{
    display: flex;
    flex-direction: column;
    position: fixed;
    z-index: 5;
    background: #fff;
    top: 200px;
    left: 50%;
    margin-left: -670px;
    width: 47px;
    border: 1px solid #d0cecf;
    cursor: pointer;
  }
  .fixedtool>div{
    display: flex;
    flex-direction: row;
    justify-content:flex-start;
    border-bottom: 1px solid #d0cecf;
    background: url('/mock/images/icon/medicineIconGray.png') center 8px no-repeat;
    background-size: 19px 22px;
    word-break: break-all;
    color: #666;
    padding: 40px 8px 18px 12px;
  }
  .fixedtool>div:last-child{
    border-bottom: 0;
  }
  @media screen and (max-width:1280px){
    .fixedtool {
      left:0;
      margin-left: 0;
    }
  }
</style>

<style lang="scss">
  @mixin background($color){
    background: $color;
    width: 100px;
    height: 100px;
    border: 3px solid #333;
  }
  .testtest {
    @include background(blue);
  }
  .advertisement {
    margin: 30px 0;
    img {
      width: 100%;
    }
  }
  .nav_bottom {
    width: 100%;
    height: 2px;
    background: #1177b6
  }
</style>
